<template>
  <div class="text-center">
      <div class="border border-primary rounded-circle text-primary">
        <font-awesome-icon icon="heart" class="fa-3x" />
        <font-awesome-icon icon="car" class="fa-6x" />
      </div>
      <br>
      <h3>{{$t("success.thankYou")}}</h3>
      <h4>{{$t("success.message")}} <strong>{{form.clientEmail}}</strong>  {{$t("success.message2")}}</h4>
      <br>
      <div class="btn-group text-center" role="group" >
          <router-link to="/" class="btn btn-secondary">{{$t("success.newReservation")}}</router-link>
          <a target="_blank" :href="voucherUrl()" class="btn btn-primary">{{$t("success.viewVoucher")}}</a>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Success',
  data() {
    return {
    }
  },
  methods: {
    voucherUrl() {
      return `${process.env.VUE_APP_BT_API}reservations?token=${this.token}`;
    },
    generateTransaction(summary) {
      return {
        transaction_id: `${summary.id}`,
        affiliation: summary.affiliation || 'Btransfer reservation',
        currency:  summary.currency,
        value: summary.total,
        tax: summary.tax
      };
    },
    generateItems(summary, items, defaultName, defaultCat) {
      return items.map(item => {
        return {
          item_id: `${summary.id}`,
          item_name: item.name || defaultName,
          item_category: item.category || defaultCat,
          price: item.price,
          quantity: item.quantity
        }
      });
    },
    runEcommerceData() {
      return this.$http.get('reservations/summary', {params: {token: this.token}}).then((res) => {
        this.form.clientEmail = res.body.email
        this.$i18n.locale = res.body.lang
        const summary = res.body;
        const transaction = this.generateTransaction(summary);
        const services = this.generateItems(summary, summary.services || [], 'transportation', 'transfers');
        const extras = this.generateItems(summary, summary.extras || [], 'extra', 'extras');
        transaction.items = services.concat(extras);
        if (this.settings.gaId) {
          this.$store.commit('addGa4Event', (gtag) => {
            gtag.purchase(transaction)
            // console.log(transaction)
          })          
        }
        // this.$store.commit('ecommerceTransaction', transaction);
      });
    }
  },
  computed: {
    ...mapState(['form', 'settings']),
    token() {
      return this.$store.state.voucherToken ? this.$store.state.voucherToken : this.$route.query.token;
    }
  },
  mounted() {
    if (this.token) {
      this.runEcommerceData();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .border{
    border-width: 5px !important;
    width: 250px;
    height: 250px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>
